

































import { Component, Vue, Prop } from 'vue-property-decorator';

import Arrow from '@/components/icons/Arrow.vue';
import Tab from '@/componentsV2/molecules/Tab/Tab.vue';

type TabItem = {
  key: string;
  label: string;
};

type TriggerPosition = 'left' | 'right';

@Component({
  components: {
    Arrow,
    Tab
  }
})
export default class TabsHeader extends Vue {
  @Prop({ default: () => [] }) tabs!: TabItem[];
  @Prop(String) activeTabKey!: string;
  @Prop(String) instanceId!: string;

  observer: IntersectionObserver | null = null;
  triggerVisibility: Record<TriggerPosition, boolean> = {
    left: false,
    right: false
  };
  scrollPosition = 0;

  mounted() {
    const containerId = `#${this.instanceId}`;
    const triggerClass = '.tabs__trigger';
    const targets = document.querySelectorAll(`${containerId} ${triggerClass}`);

    this.observer = new IntersectionObserver(
      entries => {
        for (const entry of entries) {
          const position = entry.target.getAttribute(
            'data-position'
          ) as TriggerPosition;

          if (!position) continue;

          this.triggerVisibility[position] =
            !entry.isIntersecting && !!position;
        }
      },
      {
        root: document.querySelector(containerId),
        threshold: 0
      }
    );

    for (const target of targets) {
      this.observer.observe(target);
    }
  }

  beforeDestroy() {
    if (this.observer) this.observer.disconnect();
  }

  handleSwipe(position: TriggerPosition) {
    const containerEl = document.getElementById(this.instanceId);

    if (!containerEl) return;

    const targets = document.querySelectorAll<HTMLElement>(
      `#${this.instanceId} > .tabs__item`
    );

    for (const target of targets) {
      const targetOffset = target.offsetLeft;
      const targetWidth = target.getBoundingClientRect().width;

      const offsetLimit = containerEl.clientWidth - targetWidth;

      if (targetOffset >= offsetLimit) {
        const ARROW_SIZE_AND_GUTTER = 54;

        const mapper: Record<TriggerPosition, any> = {
          left: () => {
            this.scrollPosition -= targetOffset - ARROW_SIZE_AND_GUTTER;
          },
          right: () => {
            this.scrollPosition += targetOffset - ARROW_SIZE_AND_GUTTER;
          }
        };

        mapper[position]();

        break;
      }
    }

    containerEl.scroll({
      left: this.scrollPosition,
      behavior: 'smooth'
    });
  }
}
